/**
 * Which wallet a platform has, apart from Stripe's SDK (walletPay.ts), so
 * what only needs to know — the checkout's shape — does not load it.
 */
export type WalletKind = "applePay" | "googlePay";

/** The wallet this platform has, if any. */
export const walletOf = (os: string): WalletKind | null =>
  os === "ios" ? "applePay" : os === "android" ? "googlePay" : null;

export const WALLET_LABEL: Record<WalletKind, string> = {
  applePay: "Apple Pay",
  googlePay: "Google Pay",
};
